// <s-countdown> — ticks down to data-end (ISO date) and fills [data-unit] digits each second.
// Hides its closest [data-countdown-region] once the end time passes so expired deals vanish.
class SCountdown extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const end = Date.parse(this.dataset.end || "");
    const region = this.closest("[data-countdown-region]") || this;
    if (Number.isNaN(end)) {
      window.clearInterval(this.#timer);
      return;
    }

    const remaining = Math.max(0, end - Date.now());
    if (remaining === 0) {
      window.clearInterval(this.#timer);
      // Keep expired bars visible in the editor so merchants can still select and update them.
      if (!this.hasAttribute("data-design-mode")) region.hidden = true;
    }

    const total = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };

    this.querySelectorAll("[data-unit]").forEach((el) => {
      const value = values[el.dataset.unit] ?? 0;
      el.textContent = String(value).padStart(2, "0");
    });
  }
}

if (!customElements.get("s-countdown")) {
  customElements.define("s-countdown", SCountdown);
}
